import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';
import TablePagination from '@material-ui/core/TablePagination';
import Empty from '../../components/common/Empty';
import Link from '../../components/common/Link';
import * as UsersActionCreators from '../../redux/users';
import * as UiActionsCreators from '../../redux/ui';
import { SHOWING_FIELDS_USERS, ROWS_PER_PAGE } from '../../constants';
import TextField from '@material-ui/core/TextField';

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const EventsTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const EventsTableHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const EventsTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;

const InputField = styled(TextField)`
  && {
    margin-right: 20px;
  }
`;
const SearchButton = styled(Button)`
  && {
    margin-left: 20px;
  }
`;
const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

const Verified = styled.span`
  color: green;
`;

const NotVerified = styled.span`
  color: red;
  white-space: nowrap;
`;

class UsersPage extends Component {
  constructor() {
    super();
    this.state = {
      showingPage: 0,
      fisrtName: '',
      lastName: '',
      email: ''
    };
  }
  componentDidMount() {
    this.clearSearchUser();
  }

  getCellNames = () => {
    return [
      'id',
      'first_name',
      'last_name',
      'created_at',
      'email',
      'verified',
      'reset_password',
      'actions'
    ];
  };

  renderTableCellNames = () => {
    const cellNames = this.getCellNames();
    return cellNames.map((name, i) => {
      if (SHOWING_FIELDS_USERS.includes(name)) {
        const displayName = startCase(name);
        return (
          <EventsTableHeadFields key={i}>{displayName}</EventsTableHeadFields>
        );
      }
      return null;
    });
  };

  onEnter = e => {
    if (e.key === 'Enter') {
      this.onClickSearchUser();
    }
  };

  clearSearchUser = () => {
    const { actions } = this.props;
    this.setState({
      showingPage: 0,
      fisrtName: '',
      lastName: '',
      email: ''
    });
    actions.getUsers({
      limit: ROWS_PER_PAGE,
      offset: 0
    });
  };

  async sendResetPasswordMail(e, user) {
    e.preventDefault();
    const { actions } = this.props;
    await actions.sendResetPasswordMail({
      email: user.email
    });
    await actions.getUsers();
    actions.showNotification({
      message: 'Reset password email has been sent successfully',
      type: 'success'
    });
  }
  handleChangePage = (event, page) => {
    const { actions } = this.props;
    let filters = {};
    const { fisrtName, lastName, email } = this.state;
    if (fisrtName) {
      filters.first_name = fisrtName;
    }
    if (lastName) {
      filters.last_name = lastName;
    }
    if (email) {
      filters.email = email;
    }
    let actionParams = {
      limit: ROWS_PER_PAGE,
      offset: page
    };
    if (filters && Object.keys(filters).length) {
      actionParams.filters = filters;
    }
    actions.getUsers(actionParams);
    this.setState({
      showingPage: page
    });
  };

  renderTableBody = () => {
    const { users } = this.props;
    if (!users) return <TableRow />;

    const cellNames = this.getCellNames();
    return users.map((user, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            if (SHOWING_FIELDS_USERS.includes(field)) {
              if (field) {
                let value;
                if (field === 'created_at' || field === 'start_date') {
                  value = user[field]
                    ? moment(user[field]).format('LLLL')
                    : '-';
                } else if (typeof user[field] === 'boolean') {
                  value = user[field] ? (
                    <Verified>verified</Verified>
                  ) : (
                    <NotVerified>not verified</NotVerified>
                  );
                } else if (field === 'actions') {
                  return (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Link to={`/users/${user.id}/edit`}>
                          <Button variant="outlined" color="primary">
                            Edit
                          </Button>
                        </Link>
                      </EditButtonContainer>
                    </TableCell>
                  );
                } else if (field === 'reset_password') {
                  return user.email ? (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={e => this.sendResetPasswordMail(e, user)}
                        >
                          Send email
                        </Button>
                      </EditButtonContainer>
                    </TableCell>
                  ) : (
                    <TableCell key={index}>No email</TableCell>
                  );
                } else {
                  value = user[field];
                }
                return <TableCell key={index}>{value}</TableCell>;
              }
            }
            return null;
          })}
        </TableRow>
      );
    });
  };

  renderTable = () => {
    const { ui, meta } = this.props;
    const { showingPage } = this.state;
    if (ui === 'complete') {
      return (
        <Fragment>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
          <EventsTable>
            <EventsTableHead>
              <TableRow>{this.renderTableCellNames()}</TableRow>
            </EventsTableHead>
            <TableBody>{this.renderTableBody()}</TableBody>
          </EventsTable>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
        </Fragment>
      );
    }
    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);
  onChangeInput(field, value) {
    this.setState({ [field]: value });
  }
  onClickSearchUser = () => {
    const { actions } = this.props;
    const { fisrtName, lastName, email } = this.state;
    let filters = {};
    if (fisrtName) {
      filters.first_name = fisrtName;
    }
    if (lastName) {
      filters.last_name = lastName;
    }
    if (email) {
      filters.email = email;
    }
    let actionParams = {
      limit: ROWS_PER_PAGE,
      offset: 0
    };
    if (filters && Object.keys(filters).length) {
      actionParams.filters = filters;
    }
    actions.getUsers(actionParams);
  };
  render() {
    const { fisrtName, lastName, email } = this.state;
    return (
      <div>
        <InputField
          id="search"
          label="Search by First Name"
          type="search"
          margin="normal"
          onChange={e => this.onChangeInput('fisrtName', e.target.value)}
          onKeyPress={this.onEnter}
          value={fisrtName}
        />
        <InputField
          id="search"
          label="Search by Last Name"
          type="search"
          margin="normal"
          onChange={e => this.onChangeInput('lastName', e.target.value)}
          onKeyPress={this.onEnter}
          value={lastName}
        />
        <InputField
          id="search"
          label="Search by Email"
          type="search"
          margin="normal"
          onChange={e => this.onChangeInput('email', e.target.value)}
          onKeyPress={this.onEnter}
          value={email}
        />
        <SearchButton variant="raised" onClick={() => this.clearSearchUser()}>
          Clear
        </SearchButton>
        <SearchButton
          variant="contained"
          color="primary"
          onClick={() => this.onClickSearchUser()}
        >
          Search
        </SearchButton>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users.users,
  meta: state.users.meta,
  ui: state.ui.uiState
});

const ActionCreators = Object.assign(
  {},
  UsersActionCreators,
  UiActionsCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);



// WEBPACK FOOTER //
// ./src/pages/users/index.js